const $ = require('jquery');

const openMewsDistributor = ($form, mews_id, mews_booking_url) => {
    
    const room_id = $form.find('input[name=room]').val();
    const locale = $form.find('input[name=locale]').val();
    const adults = $form.find('input[name=adult]').val();
    const children = $form.find('input[name=child]').val();
    const promo = $form.find('input[name=promo]').val();
    const arrive = $form.find('input[name=arrive]').val();
    const depart = $form.find('input[name=depart]').val();

    if(mews_booking_url) {

        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', mews_booking_url);
        //form.setAttribute('target', '_blank');

        const params = [];

        params['mews_id'] = mews_id;
        params['room_id'] = room_id;
        params['locale'] = locale;
        params['adults'] = adults;
        params['children'] = children;
        params['promo'] = promo;
        params['arrive'] = arrive;
        params['depart'] = depart;
      
        for (const key in params) {
            if(params[key] !== undefined) {
                const input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', key);
                input.setAttribute('value', params[key]);
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
        
        // const params = new URLSearchParams({
        //     mews_id, room_id, adults, children, promo, arrive, depart
        // });

        //return window.location = mews_booking_url + '?' + params.toString();
    } else {
        const arrive_parts = arrive.split('/');
        const start = new Date(arrive_parts[2], arrive_parts[1] - 1, arrive_parts[0]);

        const depart_parts = depart.split('/');
        const end = new Date(depart_parts[2], depart_parts[1] - 1, depart_parts[0]);

        Mews.Distributor({
            configurationIds: [mews_id]
        }, (distributor) => {
            // Some default settings
            distributor.setLanguageCode(locale);
    
            distributor.setStartDate(start);
            distributor.setEndDate(end);
            distributor.setVoucherCode(promo);
            distributor.setAdultCount(parseInt(adults));
            distributor.setChildCount(parseInt(children));
    
            distributor.open();
            if(room_id) {
                distributor.showRates(room_id);
            } else {
                distributor.showRooms();
            }
    
        }, {
            dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
        });
    }
}

$(function() {

    $('.booking-form-mews').on('submit', function(e) {
        const $form = $(this);
        const mews_id = $form.find('input[name="hotel"]:checked').data('mews-id');
        const mews_booking_url = window.mews_booking_url || false;

        if(mews_id) {
            e.preventDefault();
            return openMewsDistributor($form, mews_id, mews_booking_url);
        }
    });

    $('.booking-form-mews-link').on('click', function(e) {
        e.preventDefault();

        const anchor = $(this);
        const mews_id = anchor.data('hotel');
        const room_id = anchor.data('room');
        const mews_booking_url = window.mews_booking_url || false;

        if(mews_booking_url) {
            const params = new URLSearchParams({
                mews_id, room_id
            });
            return window.open(mews_booking_url + '?' + params.toString());
        } else {
            Mews.Distributor({
                configurationIds: [mews_id]
            }, (distributor) => {
                // Some default settings
                distributor.setLanguageCode(locale);
                distributor.open();
    
                if(room_id) {
                    distributor.showRates(room_id);
                } else {
                    distributor.showRooms();
                }
    
            }, {
                dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
            });
        }

        return false;
    });
});